import React from "react";
import "../../../css/TotalWeekSubsc.css";
import {
  ComposedChart,
  Tooltip,
  XAxis,
  CartesianGrid,
  Legend,
  YAxis,
  Bar,
  ResponsiveContainer,
} from "recharts";

interface TotalWeekSubscProps {
  TotalWeekSubsc: { week: string; subsc: number }[];
}

const TotalWeekSubsc = ({ TotalWeekSubsc }: TotalWeekSubscProps) => {
  return (
    <div className="week_total_subsc_container">
      <h2 className="week_total_subsc_title">曜日別登録者数(累計)</h2>
      <ResponsiveContainer height="70%" width="90%">
        <ComposedChart height={300} data={TotalWeekSubsc} className="bar_chart">
          <XAxis dataKey="week" />
          <YAxis dataKey="subsc" />
          <Tooltip />
          <Legend />
          <CartesianGrid stroke="#f5f5f5" />
          <Bar
            dataKey="subsc"
            barSize={20}
            stroke="rgba(34, 80, 162, 0.2)"
            fillOpacity={1}
            fill="#4cceac"
            name="登録者数"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TotalWeekSubsc;
